import PrintHeaderSubtitle from './View'
export default PrintHeaderSubtitle